"use strict";var $export=require("./_export");$export($export.S,"Number",{MIN_SAFE_INTEGER:-9007199254740991});